// lib
import React from "react";
import PropTypes from "prop-types";
import { ListItem, ListItemIcon } from "@material-ui/core";
import AuthorIcon from "@material-ui/icons/Person";
import GroupIcon from "@material-ui/icons/SupervisedUserCircle";
import ListAltIcon from '@material-ui/icons/ListAlt';
import RoomIcon from "@material-ui/icons/MeetingRoom";
import ScheduleIcon from "@material-ui/icons/Schedule";
import PeopleAltIcon from "@material-ui/icons/PeopleAlt";

const Icons = {
  authors: AuthorIcon,
  groups: GroupIcon,
  rooms: RoomIcon,
  schedule: ScheduleIcon,
  trombinoscope: ListAltIcon,
  countStudent: PeopleAltIcon,
  countOptionalAttendees: PeopleAltIcon,
  countMandatoryAttendees: PeopleAltIcon,
};

const embedWithComma = (key, content) => (
  <span key={key}>
    <span>, </span>
    {content}
  </span>
);

const Item = ({ type, contents, links, emails }) => {
  const Icon = Icons[type];
  let contentEntities = contents;
  if (links) {
    contentEntities = contents.map((c, index) => {
      const e = links[index] ? (
        <a key={c} href={links[index]} target="_blank" rel="noopener noreferrer">
          {c}
        </a>
      ) : (
        c
      );
      return index ? embedWithComma(c, e) : e;
    });
  }
  if (emails) {
    contentEntities = contents.map((c, index) => {
      const e = emails[index] ? (
        <a key={c} href={`mailto:${emails[index]}`}>
          {c}
        </a>
      ) : (
        c
      );
      return index ? embedWithComma(c, e) : e;
    });
  }
  return (
    <ListItem>
      <ListItemIcon>
        <Icon />
      </ListItemIcon>
      <p>{contentEntities}</p>
    </ListItem>
  );
};

Item.propTypes = {
  type: PropTypes.string.isRequired,
  contents: PropTypes.oneOfType([PropTypes.array, PropTypes.string]).isRequired,
  links: PropTypes.array,
  emails: PropTypes.array,
};

Item.defaultProps = {
  links: null,
  emails: null,
};

export default Item;
